module.exports = require('./dist/shared/lib/dynamic')
